export const SSH_PORT = 22;

export const ENABLE_SSH_COMMAND = `brev enable-ssh --ssh-port ${SSH_PORT}`;
export const GRANT_SSH_COMMAND = "brev grant-ssh";
